var React = require('react');

function AppleLogo (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"Slice Copy 3"),React.createElement("path",{"d":"M22.085 5.305C24.581 2.016 28.05 2 28.05 2s.516 3.093-1.963 6.072c-2.647 3.18-5.656 2.66-5.656 2.66s-.565-2.502 1.654-5.427zm-1.337 7.593c1.284 0 3.667-1.764 6.768-1.764 5.34 0 7.44 3.799 7.44 3.799s-4.108 2.1-4.108 7.196c0 5.749 5.117 7.73 5.117 7.73s-3.577 10.068-8.409 10.068c-2.219 0-3.944-1.495-6.282-1.495-2.383 0-4.748 1.551-6.288 1.551-4.412 0-9.986-9.55-9.986-17.228 0-7.553 4.718-11.516 9.143-11.516 2.877 0 5.11 1.66 6.605 1.66z","fillRule":"nonzero","stroke":"#979797","fill":"none","strokeLinecap":"round","strokeLinejoin":"round","key":1})]);
}

AppleLogo.defaultProps = {"width":"42","height":"42","viewBox":"0 0 42 42"};

module.exports = AppleLogo;

AppleLogo.default = AppleLogo;
